import { render, staticRenderFns } from "./HistoryMail.vue?vue&type=template&id=3f8162e8&"
import script from "./HistoryMail.vue?vue&type=script&lang=js&"
export * from "./HistoryMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports